import axios, { AxiosResponse, AxiosError } from 'axios';
import { sessionServiceApi } from '../../helpers/globalConfig';
import { ISingleUseLaunchResponse } from '../../interface/ISingleUseLaunch.interface';

const isReceiverPresent = async (receiverHost: string, receiverVersion: string): Promise<boolean> => {
    let result = await axios.get(`https://${receiverHost}/html5client/${receiverVersion}/configuration.js`)
        .then((response: AxiosResponse) => {
            return response.status === 200;
        })
        .catch((err: AxiosError) => { return false; });

    return result;
}

const logTiming = (startTime: number, response: any, category: string): void => {
    console.log('Citrix-TransactionId: ', response.headers['citrix-transactionid'], `, startTime: ${startTime}`, `, category: ${category}`); // NOSONAR
}
const logError = (e: any) => {
    const operation = e.config.method + ' ' + e.config.url;
    const result = e.status !== 0 ? e.status : 'Could not connect';
    const message = operation + ' : ' + result;
    console.log(message); // NOSONAR
    console.log(e); // NOSONAR

    return Promise.reject(e);
}

const deleteIcaFileTicket = (customer: string, ticket: string): Promise<any> => {
    const startTime = Date.now();
    const baseUrl = sessionServiceApi.replace('[customer]', encodeURIComponent(customer));

    return axios.delete<any>(`${baseUrl}/singleuse/${encodeURIComponent(ticket)}`)
        .then(response => {
            logTiming(startTime, response, 'Delete IcaFile ticket');
        }, logError);
}


const getSingleUseLaunch = (customer: string, ticket: string, fastLaunch: boolean, browserId: string): Promise<ISingleUseLaunchResponse> => {
    const startTime = Date.now();
    const baseUrl = sessionServiceApi.replace('[customer]', encodeURIComponent(customer));

    return axios.get<ISingleUseLaunchResponse>(`${baseUrl}/singleuse/${encodeURIComponent(ticket)}`, {params: {browserId : browserId, fastLaunch : fastLaunch}})
        .then(response => {
            logTiming(startTime, response, 'Single Use Launch');
            return response.data;
        }, logError);
}

export {
    deleteIcaFileTicket,
    getSingleUseLaunch,
    isReceiverPresent,
    logTiming,
    logError
}